import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {injectIntl} from 'react-intl';
import './index.scss';
import {RenderInput} from './composites/RenderInput';
import {RenderLoadingIcon} from './composites/RenderLoadingIcon';
import {RenderClearIcon} from './composites/RenderClearIcon';
import {RenderErrorMessage} from './composites/RenderErrorMessage';

export class InputField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: props.formatter(props.defaultValue) || '',
      editMode: props.editMode || false
    };
  }

  static propTypes = {
    autoComplete: PropTypes.string,
    baseInputFunctions: PropTypes.bool,
    className: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
      PropTypes.object
    ]),
    containerClass: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
      PropTypes.object
    ]),
    disabled: PropTypes.bool,
    editMode: PropTypes.bool,
    errorMessage: PropTypes.any,
    formatter: PropTypes.func,
    id: PropTypes.string.isRequired,
    inputRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({current: PropTypes.node})
    ]),
    intl: PropTypes.object.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    loading: PropTypes.bool,
    max: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
    maxLength: PropTypes.number,
    min: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
    minLength: PropTypes.number,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onInvalid: PropTypes.func,
    pattern: PropTypes.string,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired, // required for accessibility
    required: PropTypes.bool,
    step: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    success: PropTypes.bool,
    tabIndex: PropTypes.number,
    type: PropTypes.string,
    defaultValue: PropTypes.string
  };

  static defaultProps = {
    formatter: (value) => value,
    onBlur: () => {},
    onChange: () => {},
    onFocus: () => {},
    onInvalid: () => {}
  };
  
  UNSAFE_componentWillReceiveProps({defaultValue: nextDefaultValue}) {
    const {defaultValue} = this.props;
    if (defaultValue !== nextDefaultValue) {
      this.setState({
        inputValue: nextDefaultValue
      });
    }
  }

  handleChange = (e) => {
    const {disabled, onChange} = this.props;
    if (disabled) {
      return;
    }

    onChange(e);
    this.updateLocalState(e);
  };
  
  clearInput = () => {
    this.props.onChange('');
    this.setState({
      inputValue: ''
    });
  };

  onFocus = (e) => {
    const {onFocus, baseInputFunctions} = this.props;
    onFocus(e);
    if (baseInputFunctions) {
      this.setState({
        editMode: true
      });
    }
  };

  onBlur = (e) => {
    const {onBlur, baseInputFunctions} = this.props;
    onBlur(e);
    if (baseInputFunctions) {
      this.setState({
        editMode: false
      });
    }
  };

  updateLocalState({target: {value}}) {
    const {pattern, formatter} = this.props;
    if (value && pattern && !RegExp(pattern).test(value)) {
      return;
    }

    this.setState({
      inputValue: formatter(value)
    });
  }
  
  render() {
    const {
      containerClass,
      editMode,
      errorMessage,
      formatter,
      intl,
      loading,
      success,
      error,
      inputValue: inputValueFromProps,
      onChange,
      defaultValue,
      ...otherProps
    } = this.props;
    const inputValue = inputValueFromProps || this.state.inputValue;

    const containerClassNames = cx(
      'InputField__container',
      {
        'InputField__container--with-icon': loading || success || editMode
      },
      containerClass
    );

    const inputStatus =
      error || errorMessage ? 'error' : success ? 'success' : undefined;

    return (
      <div className={containerClassNames}>
        <RenderInput
          {...otherProps}
          status={inputStatus}
          value={inputValue}
          onChange={this.handleChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        />
        {loading && <RenderLoadingIcon intl={intl} />}
        {editMode && (
          <RenderClearIcon onIconClick={this.clearInput} intl={intl} />
        )}
        {errorMessage && (
          <RenderErrorMessage errorMessage={errorMessage} intl={intl} />
        )}
      </div>
    );
  }
}

export default injectIntl(InputField);
